import React, { useEffect, useState } from "react";
import { SmartLoader, SmartSoftButton } from "soft_digi";
import { TASK_API_URLS } from "../../api/TaskApiUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { SdsDtChangeDateFormat } from "../../services/core/DateService";
import { post } from "../../services/smartApiService";
import config from "../../config/config";

const CERT_URL = config.CLIENT_URL || "";

interface AlertProps {
  type?: string;
  dataIn: any;
  loadData: () => void;
  setSignedCert: (cert: any) => void;
}
const DscCheckAlert: React.FC<AlertProps> = ({
  type,
  dataIn,
  loadData,
  setSignedCert,
}) => {
  const { closeModal } = useSiteContext();
  const [certificates, setCertificates] = useState<any>([]);
  const [clientStatus, setClientStatus] = useState<boolean>(true);
  const [certNotFound, setCertNotFound] = useState<boolean>(false);
  const [cert, setCert] = useState<any>({});

  const postData = async (url: string, data: any): Promise<any> => {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const errorDetails = await response.text(); // Read the error body
      throw new Error(errorDetails);
    }
    return response.json(); // Assumes the response is JSON
  };

  const filteredCertificates = () => {
    return certificates.filter((obj: any) => {
      // return obj.isHsm===true && obj.keyUsage.includes("Digital Signature") && !(obj.commonName.includes("localhost") || obj.commonName.includes("Adobe"))
      return (
        obj.isHsm === true &&
        !(
          obj.commonName.includes("localhost") ||
          obj.commonName.includes("Adobe")
        )
      );
    });
  };

  /**
   *
   */
  const checkCertificateService = (result: any) => {
    // let _filtered_certificates = filteredCertificates();
    let userCertificate = dataIn?.empDsc[0];
    let cert_found = result.find(
      (obj: any) => obj.distinguishedName == userCertificate.dsc_dn
    );
    console.log(" user certifcate ", userCertificate, result);

    if (cert_found) {
      setSignedCert(userCertificate);
      closeModal();
    } else {
      setCertNotFound(true);
    }
  };

  const loadAndCheckCertificate = async () => {
    try {
      SmartLoader.showLoader("Fetching Certificates.... Please Wait");

      const result = await postData(CERT_URL + "/Sign/certificates", {});
      setClientStatus(true);
      setCertificates(result);
      SmartLoader.hideLoader();
      if (type == "CHECK") {
        checkCertificateService(result);
      }
      // signedHashBase64
      // console.log(" reseut ", result);
    } catch (err) {
      setClientStatus(false);
      SmartLoader.hideLoader();
    }
  };

  useEffect(() => {
    loadAndCheckCertificate();
  }, []);

  const registerDsc = () => {
    SmartLoader.showLoader("Certificate Registering.... Please Wait");
    const payload = {
      task_id: "",
      cert_pfx: "",
      cert_pem: cert.pem,
      cert_type: "HSM",
      user_name: dataIn?.task_user_name,
      user_id: dataIn?.task_user_id,
      user_cn: cert.commonName,
      user_dn: cert.distinguishedName,
      notBefore: SdsDtChangeDateFormat(cert.notBefore, "YYYY-MM-DD HH:mm:ss"),
      notAfter: SdsDtChangeDateFormat(cert.expiryDate, "YYYY-MM-DD HH:mm:ss"),
      serialNumber: cert.serialNumber,
      cert_pin: "",
    };
    const subscription = post(TASK_API_URLS.REGISTER_DSC, payload, {
      showLoading: false,
    }).subscribe((response) => {
      loadData();
      closeModal();
      console.log("response ", response.data.data);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const showClientNotRunningMsg = () => {
    return (
      <div className="is-size-1 has-text-danger">
        Client Software Either Not Installed or Not Running.. Please Install &
        Run
        <div className="has-text-centered mt-4">
          <SmartSoftButton
            label="RELOAD"
            leftIcon="fa-signature"
            classList={["button is-danger px-6 ml-5"]}
            onClick={() => loadAndCheckCertificate()}
          />
        </div>
      </div>
    );
  };

  const showAvailableCertificates = (_filtered_certificates: any) => {
    return _filtered_certificates.map((obj: any) => (
      <div
        className={`card column ${
          obj.commonName == cert.commonName ? "is-active" : ""
        }`}
      >
        <div className="card-content" onClick={() => setCert(obj)}>
          <div className="media">
            <div className="media-left">
              <span className="icon is-size-1 mt-4">
                <i className="fa fa-file-o" aria-hidden="true"></i>
              </span>
            </div>
            <div className="media-content">
              <p className="title is-4">{obj.commonName}</p>
              <p className="subtitle is-6">{obj.expiryDate}</p>
              <p className="subtitle is-6">{obj.issuer}</p>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const NoCertificatesFound = () => {
    return (
      <div>
        No Certificates Found Please insert the Smart Card & Click on Refresh
        Button
      </div>
    );
  };

  const certificateNotFound = () => {
    let _filtered_certificates = filteredCertificates();
    return (
      <div>
        The Registered Certificate Not Found. Please insert HSM and click on
        Refresh Button (or) Click to Register to register new certificate
        {_filtered_certificates.length > 0 &&
          showAvailableCertificates(_filtered_certificates)}
        <div className="has-text-centered mt-4">
          <SmartSoftButton
            label="REGISTER"
            leftIcon="fa-signature"
            classList={["button is-primary px-6"]}
            onClick={() => registerDsc()}
          />
          <SmartSoftButton
            label="RELOAD"
            leftIcon="fa-signature"
            classList={["button is-danger px-6 ml-5"]}
            onClick={() => loadAndCheckCertificate()}
          />
        </div>
      </div>
    );
  };

  const selectCertificateBox = () => {
    let _filtered_certificates = filteredCertificates();
    return (
      <>
        {_filtered_certificates.length > 0 &&
          showAvailableCertificates(_filtered_certificates)}
        {_filtered_certificates.length == 0 && NoCertificatesFound()}
        <div className="has-text-centered mt-4">
          <SmartSoftButton
            label="REGISTER"
            leftIcon="fa-signature"
            classList={["button is-primary px-6"]}
            onClick={() => registerDsc()}
          />
          <SmartSoftButton
            label="RELOAD"
            leftIcon="fa-signature"
            classList={["button is-danger px-6 ml-5"]}
            onClick={() => loadAndCheckCertificate()}
          />
        </div>
      </>
    );
  };

  return (
    <div>
      {!clientStatus && showClientNotRunningMsg()}
      {dataIn?.empDsc?.length === 0 && selectCertificateBox()}
      {certNotFound && certificateNotFound()}
    </div>
  );
};

export default DscCheckAlert;
